<template>
  <div id="mainPage" class="h-screen display w-full" v-if="images.length">
    <!-- <div class="lg:flex lg:items-center lg:justify-between lg:mx-12 mx-12"> -->
    <!-- <div class="flex justify-center lg:justify-start mt-4 min-w-0"> -->
    <div
      class="w-full items-center place-items-center py-12 border-b-2 border-gray-200"
    >
      <div  class="lg:flex lg:items-center lg:justify-between my-4 lg:mx-12 mx-12">
        <div>
          <h2
            class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
          >
            {{ batchName }}
          </h2>
        </div>
        <div  class="mt-4 gap-3 w-min flex flex-col justify-center md:flex-row lg:mt-0 lg:ml-4">
          <button class="flex items-center text-white bg-woo hover:translate-x-0 hover:bg-hoverwoo p-2 m-1" @click="filterMenu=true">
            <FilterIcon class="mouse"/> <span>Filter</span>
          </button>
        </div>
      </div>
      <div class="mt-4 justify-center flex lg:mt-0 lg:ml-4">
        <span class="sm:ml-3"> </span>
      </div>
    </div>
    <div class="w-full mt-16 m-4 flex flex-wrap items-center justify-center">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="p-4 m-1 border border-solid border-gray shadow-lg image opacity-70 justify-between"
        :id="'image-' + image.id"
        @click="selectImage(image.id)"
        style="width: fit-content; height: min-content"
      >
        <div class="flex flex-row justify-between relative">
          <ImageComponent

            :key="reRender"
            :url="image.url + '?session=' + session"
            :imageId="image.id"
            :arrayBuffer="image.arrayBuffer"
            style="width: 200px; height: 200px;"
            :style="
              'border: 5px solid' +getBorderColor(image)"
          />
          <!-- <div
            v-if="image.status.id == 1"
            class="w-4 h-4 bg-green-500 rounded-full absolute"
          ></div>
          <div v-else class="w-4 h-4 bg-woo rounded-full absolute"></div> -->
        </div>
      </div>
    </div>
    <router-view />
    <!-- Pagination -->
    <div
      class="bg-white w-full px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
    >
      <t-pagination
        :total-items="totalImages"
        :per-page="perPage"
        v-model="currentPage"
        @change="handler"
        :classes="{
          wrapper: 'bg-white mx-auto text-center flex space-x-2',
          element: 'w-8 h-8 rounded-full',
          activeElement: 'w-8 h-8 rounded-full',
          disabledElement: 'w-8 h-8 rounded-full',
          ellipsisElement: 'w-8 h-8 rounded-full hidden md:inline',
          activeButton:
            'border border-woo bg-woo w-full h-full rounded-full text-white hover:bg-blue-600 transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
          disabledButton:
            'border border-gray-200  opacity-25 w-full h-full rounded-full cursor-not-allowed transition duration-100 ease-in-out',
          button:
            'border border-gray-200 hover:bg-blue-100 hover:border-blue-100 rounded-full w-full h-full transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
          ellipsis: '',
        }"
      />
    </div>
    <filterMenu v-if="filterMenu" :fields="fields" :currentFields="selectedFields" :sortOptions="sortOptions"
      :sortFilter="sortFilter" :statusOptions="statusOptions" :statusFilter="statusFilter" :directionOptions="directionOptions" :sortDirection="sortDirection" @close="close"
      @filterImages="filterImages" />
  </div>
</template>

<script>
import Http, { OCR_ENDPOINTS } from "../request";
import router, { routes } from "../router/index";
import ImageComponent from "../components/ImageComponent.vue";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/solid";
import store from "../store";
import TPagination from "vue-tailwind/dist/t-pagination";
import Vue from "vue";
import VueTailwind from "vue-tailwind";
import filterMenu from "../components/filterMenu.vue";
Vue.use(VueTailwind);
import {
 FilterIcon
} from "@vue-hero-icons/outline";

export default {
  created() {
    // this.images = this.$store.state.batchImages;
    this.getIDfromURL();
    this.getImages();
  },
  data() {
    return {
      reRender: 0,
      perPage: this.$route.query.perPage? parseInt(this.$route.query.perPage):21,
      isOptionsExpanded: false,
      sortFilter: this.$route.query.sortFilter? this.$route.query.sortFilter:"creationDate",
      statusFilter:this.$route.query.statusFilter? this.$route.query.statusFilter:null,
      sortDirection:this.$route.query.sortDirection? this.$route.query.sortDirection:null,
      sortOptions: [{id:"creationDate",name:"Creation Date"}],
      statusOptions: [{id:"DONE",name:"DONE"}, {id:"IN_PROGRESS", name:"IN PROGRESS"}, {id:"IRRELEVANT", name:"IRRELEVANT"}],
      directionOptions:[{id:"ASC",name:"Ascending"},{id:"DESC",name:"Descending"}],
      batchName: null,
      totalImages: null,
      projectId: null,
      fields:[],
      currentPage: this.$route.query.currentPage? parseInt(this.$route.query.currentPage):1,
      session: store.state.id,
      images: [],
      selectedFields:this.$route.query.selectedFields? this.$route.query.selectedFields:null,
      filterMenu: false,
    };
  },
  components: {
    ImageComponent,
    TPagination,
    FilterIcon,
    filterMenu
  },
  methods: {
    getBorderColor(image){
      if(image.status.id==1){
        return '#48bb78;'
      }if(image.status.id==2){
        return '#ff7401'
      }
      return'#E40046;'
    },
    close(){
      this.filterMenu=false;
    },
    getProjectFields() {
      Http()
        .get(OCR_ENDPOINTS.projects + this.projectId + "/fields", {
          showLoader: true,
        })
        .then((response) => {
          this.fields = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    getIDfromURL() {
      this.id = parseInt(window.location.pathname.split("/")[2]);
      Http()
        .get(OCR_ENDPOINTS.batches + `${this.id}`, {
          showLoader: false,
        })
        .then((response) => {
          this.projectId=response.data.project.id;
          this.totalImages = response.data.numberOfImages;
          this.batchName = response.data.name;
        })
        .catch((error) => {})
        .finally(() => {
          this.getProjectFields();
        });
    },
    reroutePage(){
      if(this.selectedFields==""){
        this.selectedFields=null;
      }
      if(this.statusFilter==""){
        this.statusFilter=null;
      }
      if(this.sortFilter==""){
        this.sortFilter=null;
      }
      if(this.sortDirection==""){
        this.sortDirection=null;
      }
        router.push({
          path: '/batches/' + `${this.id}` + '/images',
          query: {
            perPage: this.perPage,
            sortFilter: this.sortFilter,
            currentPage: this.currentPage,
            selectedFields: this.selectedFields,
            statusFilter: this.statusFilter,
            sortDirection: this.sortDirection,
          },
        }).catch(error => {
          if (
            error.name !== 'NavigationDuplicated' &&
            !error.message.includes('Avoided redundant navigation to current location')
          ) {
            console.log('Router error: ',error)
          }
        });
    },
    getImages() {
      if(this.selectedFields==""){
        this.selectedFields=null;
      }
      this.id = parseInt(window.location.pathname.split("/")[2]);
      Http()
        .get(OCR_ENDPOINTS.batches + `${this.id}` + "/images", {
          params: {
            size: this.perPage,
            sortFields: this.sortFilter?[this.sortFilter,"id"]:['id'],
            imageStatus:this.statusFilter,
            sortDirection:this.sortDirection,
            page: this.currentPage - 1,
            annotatedFields:this.selectedFields
          },
          showLoader: true,
        })
        .then((response) => {
          
          if(response.data.images.length==0){
            this.$toast.error("Could not find images");
          }else{
            this.images = [];
            this.images = response.data.images;
            this.totalImages=response.data.totalImages;
          }
        })
        .catch((error) => {
          // this.validProject = false;
        })
        .finally(() => {});
    },
    handler(pageNumber) {
      this.reRender++;
      this.currentPage = pageNumber;
      this.reroutePage();
      this.getImages();
    },
    selectImage(id) {
      this.$parent.selectedImageID = id;
      router.push({
        path: "/annotation",
        query: { 
          selectedImageID: id, 
          batchId: this.id, 
          filteredImages: (this.selectedFields || this.statusFilter)?{images:this.images,size:this.totalImages}:null, 
          path:router.history.current.path, 
          currentPage:router.history.current.query.currentPage,
          perPage:router.history.current.query.perPage,
          selectedFields:router.history.current.query.selectedFields,
          sortDirection:router.history.current.query.sortDirection,
          sortFilter:router.history.current.query.sortFilter,
          statusFilter:router.history.current.query.statusFilter,
        },
      });
    },
    filterImages(selectedFields,sortFilters,statusFilter,sortDirection){
      this.selectedFields=selectedFields;
      this.sortFilter=sortFilters;
      this.statusFilter=statusFilter;
      this.sortDirection=sortDirection;
      this.currentPage=1; 
      this.reroutePage();
      this.getImages();
    }
  },
};
</script>

<style>
@media only screen and (max-width: 600px) {
  .display {
    align-items: center;
    flex-direction: column;
  }
}

@media only screen and (min-width: 601px) {
  .display {
    flex-wrap: wrap;
  }
}

.image {
  -webkit-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
  background: #fff;
}

.selected {
  opacity: 100;
}

.image:hover {
  -webkit-box-shadow: 1px 1px #bac4cc, 2px 2px #bac4cc, 3px 3px #bac4cc;
  box-shadow: 1px 1px #bac4cc, 2px 2px #bac4cc, 3px 3px #bac4cc;
  -webkit-transform: translateX(-3px);
  -ms-transform: translateX(-3px);
  transform: translateX(-3px);
  opacity: 100;
}

button {
  transition: all 0.3s;
}

button:hover {
  background-color: gray !important;
}

button.special:hover {
  background-color: white !important;
  color: #e40046 !important;
}
.mouse{
  cursor: pointer;
}
div.sp-pagination ul li a{
  color: black !important;
}
div.sp-result-area ul.sp-results li.sp-selected{
  color:#E40046 !important;
  font-weight: 700;
}
</style>
